// extracted by mini-css-extract-plugin
module.exports = {"main-component":"kycIcon_main-component__1H7AC"};